import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { searchInboundWorks } from './apis'
import type { InboundWorkRowDto, InboundWorkSearchReq } from './types'

export const inboundWorkSearchQueryKeys = {
  all: ['INBOUND_WORK_SEARCH'] as const,
  list: (params: InboundWorkSearchReq | null) => [...inboundWorkSearchQueryKeys.all, 'LIST', params] as const,
}

/** 조회 — params 가 null 이면(아직 [조회] 전) 부르지 않는다. 실패 알림은 전역 처리(errorToast)가 띄운다. */
export const useGetInboundWorkSearch = (params: InboundWorkSearchReq | null): UseQueryResult<InboundWorkRowDto[], Error> =>
  useQuery({
    queryKey: inboundWorkSearchQueryKeys.list(params),
    // enabled 가 null 조회를 막지만 refetch() 는 enabled 를 무시한다 — queryFn 에서도 좁힌다.
    queryFn: async () => (params ? (await searchInboundWorks(params)).data ?? [] : []),
    enabled: params !== null,
    meta: { errorToast: true },
  })
